import { Routes, Route, Navigate } from "react-router-dom";
import AuthForm from "../pages/shared/AuthForm.jsx";
import NotFound from "../pages/shared/NotFound.jsx";
import AdminRoutes from "./AdminRoutes.jsx";
import SellerRoutes from "./SellerRoutes.jsx";
import ProtectedRoute from "../components/ProtectedRoute.jsx";
import AppLayout from "../components/AppLayout.jsx";
import { getCurrentUser } from "../utils/auth.js";

export default function AppRoutes({ setUser, sidebarOpen, toggleSidebar }) {
  const currentUser = getCurrentUser();

  return (
    <Routes>
      <Route 
        path="/" 
        element={
          currentUser 
            ? <Navigate to={`/${currentUser.admin ? "admin" : "seller"}`} replace />
            : <Navigate to="/login" replace />
        } 
      />

      <Route
        path="/login"
        element={
          currentUser 
            ? <Navigate to={`/${currentUser.admin ? "admin" : "seller"}`} replace />
            : <AuthForm setUser={setUser} />
        }
      />

      <Route 
        element={
          currentUser ? (
            <AppLayout 
              sidebarOpen={sidebarOpen}
              toggleSidebar={toggleSidebar}
              setUser={setUser}
            />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      >
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute role="admin">
              <AdminRoutes />
            </ProtectedRoute>
          }
        />

        <Route
          path="/seller/*"
          element={
            <ProtectedRoute role="seller">
              <SellerRoutes />
            </ProtectedRoute>
          }
        />
      </Route>

      <Route 
        path="*" 
        element={
          currentUser ? (
            <AppLayout sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} setUser={setUser}>
              <NotFound />
            </AppLayout>
          ) : (
            <Navigate to="/login" replace />
          )
        } 
      />
    </Routes>
  );
}
